import 'react-toastify/dist/ReactToastify.css';

/**
 * アプリケーション
 */
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BrowserRouter as Router, Redirect, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import styles from './App.module.scss';
import AuthProvider from './components/auth-provider';
import AuthRoute from './components/auth-route';
import DataList from './components/data-list';
import Header from './components/header';
import Portal from './components/portal';

import { homepage } from '../package.json';

/**
 * ルーティング設定をここで行う
 */
function App(): React.ReactElement {
  return (
    <div className={`${styles.App}`}>
      <Router basename={homepage}>
        <AuthProvider>
          <Header />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnFocusLoss
            draggable
            pauseOnHover={false}
          />
          <Container fluid className={`flex-full ${styles.TopContainer}`}>
            <Row className="w-100 h-100">
              <Col className="col-12">
                <Switch>
                  <AuthRoute
                    path="/login"
                    render={() => <Redirect to="/portal" />}
                  />
                  <AuthRoute path="/portal" render={() => <Portal />} />
                  <AuthRoute path="/datalist" render={() => <DataList />} />
                  <Redirect to="/login" />
                </Switch>
              </Col>
            </Row>
          </Container>
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;
